import { useMemo } from "react";
import { AnalyticsCampaign } from "../../../types";

export function useDataClicked(analyticsData: AnalyticsCampaign[] | undefined) {
  return useMemo(
    () => ({
      data: analyticsData?.map((dataItem, index) => ({
        label: "Clicked",
        value: dataItem.audienceReached.clicked.percentage || 0,
        exactValue: dataItem.audienceReached.clicked.amount,
        backgroundColor: index === 0 ? "rgba(99, 102, 241, 0.5)" : undefined,
      })),
      title: analyticsData?.reduce(
        (acc, curr) => acc + curr.audienceReached.clicked.amount,
        0
      ),
    }),
    [analyticsData]
  );
}
